import { Button, Card, Col, Divider, Progress, Row, Tag, Tooltip } from "antd"
import { PriceTag } from "../components/atoms/PriceTag"
import { Link } from "react-router-dom"
import "../styles/Contracts.css"
import { EuroOutlined, GoldOutlined, SyncOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useFetch } from "../hooks/useFetch"
import { useEffect, useState } from "react"
import { useAuth } from "../store/AuthContext/AuthContext";
import Marquee from 'react-fast-marquee';
import moment from "moment";
import { formatPrice } from "../utils/formatPrice";
import PercentageCustom from "../components/atoms/PercentageCustom";
import { INVESTMENT_PLAN } from "../common/constants/investmentPlan";
import { INVESTMENT_TYPE } from "../common/constants/investmentType";
import { INVESTMENT_STATUS } from "../common/constants/investmentStatus";

export const Contracts = () => {

    const { data: dailyData } = useFetch(`${process.env.REACT_APP_API}/market`, {}, []);

    const { data: contracts } = useFetch(`${process.env.REACT_APP_API}/contractsClient`, {}, []);

    const { data: offers } = useFetch(`${process.env.REACT_APP_API}/productOffers/active`, {}, []);

    const { profile, setProfile } = useAuth();

    const [randomIndex, setRandomIndex] = useState(1);

    useEffect(() => {
        const newIndex = Math.floor(Math.random() * offers.length);
        setRandomIndex(newIndex);
    }, [offers]);


    useFetch(`${process.env.REACT_APP_API}/appClient`, {}, [], (data) => {
        setProfile(data);

    });


    return (<div className="general-container">

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', color:'var(--dark-accent)' }}>
            <h1 style={{ textAlign: 'center' }}>¡Hola, {profile.name}!
            </h1>
            <span class="material-symbols-outlined" style={{ color: "var(--dark-accent)", fontSize: '30px' }} >
                waving_hand
            </span>
        </div>
        
        <Marquee speed={30} gradient={false} style={{ marginTop: '15px' }}>
            <div className="ticker">
                <ul className="ul-ticker ">
                    <li><b style={{color:'var(--header-grey)'}}>Últimas 72 horas</b></li>
                    {dailyData.map((m) => {
                        return <li className="ul-ticker-li" key={m.metal}>
                            <span>{m.metalName}</span>
                            <PercentageCustom increment={m.increment} />
                        </li>
                    })} </ul>
            </div>
        </Marquee>        

        {offers.length > 0 &&
        <>          
            <Card size="small" style={{ background: "var(--accent)", margin: '10px 0px' }} >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <b>{offers[randomIndex].name}</b>
                    <Divider style={{ backgroundColor: 'black', margin: '15px 0px' }} />
                    <small >{offers[randomIndex].description}</small>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <p style={{ fontSize: '11px', fontWeight: '600' }}><Link style={{ color: 'black' }} to={'/contratos/tipos'}><b>VER MÁS</b></Link></p>
                </div>
            </Card>

        </>
        }

        <h3 style={{ marginTop: '20px', color:'var(--header-grey)' }}>Mis Contratos</h3>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '10px' }}>
            {contracts.length > 0 ? contracts.map((ct) => {
                return (
                    <Card key={ct.id}
                        bodyStyle={{ padding: '10px' }}
                        style={{ border: '.5px var(--dark-accent) solid', background:'ivory' }}>

                        <div style={{ display: 'flex', justifyContent: 'space-between', position: 'relative', marginBottom: '15px' }}>
                            <div>
                                <h3 style={{ color: 'var(--dark-accent)' }}><b>{ct?.contract?.contractInfo?.typeDescription}</b></h3>
                                <div style={{display:'flex', alignItems:'center', marginTop:'5px'}}>
                                    <PriceTag size={10} price={ct?.contract?.contractInfo?.revenue} />
                                    {/*<p style={{
                                        fontWeight: 600, fontSize: 10,
                                        color: ct?.contract?.benefit !== undefined && ct?.contract?.benefit !== 0
                                        ? ct?.contract?.benefit > 0
                                        ? 'green'
                                        : 'red'
                                        : 'inherit'
                                    }}>
                                {(ct?.contract?.benefit).toFixed(2)}%</p>*/}
                                </div>
                                
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <small>
                                    <i>{moment(ct?.contract?.contractInfo?.start).format('D [de] MMM[ de] YYYY')}</i>
                                </small>                                
                                
                                {ct?.contract?.contractInfo?.investmentPlan !== INVESTMENT_PLAN.TOTAL_FREEDOM &&

                                    <div style={{ width: '100px', position: 'absolute', top: '8px' }}>
                                        <Progress showInfo={false} size='small' percent={ct?.contract?.contractInfo?.progress} />
                                    </div>}
                            </div>
                        </div>

                        <div style={{ display: 'flex', justifyContent:'space-around' }}>
                            <div>           
                                <b>Saldo <EuroOutlined style={{color:'var(--dark-accent)'}} /></b>                         
                                <p style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>{ct?.contract?.contractInfo?.cashAccount}€</p>
                            </div>                                                                
                            <div>                                               
                                <b>Unidades <GoldOutlined style={{color:'var(--dark-accent)'}}/></b>             
                                <Tooltip placement="leftBottom" title={`${ct?.contract?.contractInfo?.unitsCostAccount} €`}><p style={{ display: 'flex', alignItems: 'center', gap: '5px', width: 'fit-content' }}>{ct?.contract?.contractInfo?.units} lingotes</p></Tooltip>
                            </div>                                                                
                        </div>
                        <br/>               
                        <Row style={{ justifyContent: 'space-between', display: 'flex' }}>
                            <Col>
                            {INVESTMENT_TYPE[ct?.lastPendingInvestment?.type] ? (
                                    <Tag color={INVESTMENT_TYPE[ct?.lastPendingInvestment?.type].color} style={{ borderRadius: '8px', minWidth: '130px', textAlign: 'center' }}>
                                        {INVESTMENT_STATUS[ct?.lastPendingInvestment?.status] && (
                                            ct?.lastPendingInvestment?.status === 'DONE' ?
                                                <span style={{ marginRight: '5px' }}><CheckCircleOutlined /></span>
                                                :
                                                <span style={{ marginRight: '5px' }}><SyncOutlined spin /></span>)}
                                        {INVESTMENT_TYPE[ct?.lastPendingInvestment?.type].name} {formatPrice(ct?.lastPendingInvestment?.revenue, 2)}€
                                    </Tag>)
                                    : <Tag style={{ borderRadius: '8px', minWidth: '130px', textAlign: 'center' }}>Sin novedad</Tag>
                                }
                                {/* <p style={{ fontSize: '11px', fontWeight: '600' }}><Link to={`contrato/${ct?.contract?.id}`}>VER MÁS {">"}</Link></p> */}
                            </Col>
                            <Button size='small' style={{ color: 'var(--dark-accent)', borderColor: 'var(--dark-accent)', fontSize: '11px', backgroundColor:'white' }}><Link to={`contrato/${ct?.contract?.id}`}><b>VER MÁS</b></Link></Button>
                        </Row>
                    </Card>
                )
            }) : <p style={{ margin: '5px' }}>Sin contratos</p>}

        </div>


    </div>
    )
}